import { getEnv } from '@luna/env';

import { clientOptionsFactory } from './widgets/clientOptions';

clientOptionsFactory.set(() => ({ baseUrl: `${getEnv().apiGatewayUrl}dashboard` }));
